import classNames from 'classnames';
import { forwardRef } from 'react';
import Typography from '@/components/atoms/typography/typography';
import Pill from '@/components/molecules/pill/pill';
import Link, { LinkProps } from '@/components/utilities/link/link';
import styles from './tab.module.scss';

export interface TabProps extends LinkProps {
  /** A number to indicate the number of items in the tab */
  count?: number;
  /** The unique id of the tab */
  id?: string;
  /** Should active styling be applied to the tab */
  isActive?: boolean;
  /** The text to show as a tab */
  text: string;
}

const Tab = forwardRef<HTMLButtonElement | HTMLAnchorElement, TabProps>(
  ({ className, count, isActive, text, ...rest }: TabProps, ref) => {
    return (
      <Link
        {...rest}
        ref={ref}
        className={classNames(styles.component, className, {
          [styles.isActive]: isActive,
        })}
      >
        <div className={styles.wrapper}>
          <Typography className={styles.tab} tagStyle="bodyMediumBold">
            {text}
          </Typography>

          {!!count && (
            <Pill className={styles.count} count={count} variant="secondary" />
          )}
        </div>
      </Link>
    );
  },
);

Tab.displayName = 'Tab';

export default Tab;
